import Modal from "react-modal";
import React, {useEffect, useState} from "react";

import './Program.generate.zip.report.dialog.scss';
import {useTranslation} from "react-i18next";
import axios from "axios";
// import 'react-day-picker/lib/style.css';
import LocalStorageUtil from "../../services/localStorageUtil";
import {ModalLog} from "../../services/interactions/elements/modal";
import AuditTrail, {PAGES} from "../../services/interactions/audit.trail";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "none",
        padding: "0px",
        boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.38)",
    }
};
Modal.setAppElement('#root');

const _Modal = ModalLog(Modal);

function ProgramDownloadZipReportsDialog({link, program, openModal, closeModal}) {
    const {t} = useTranslation(['common', 'teams', 'reports']);
    const [__download, __setDownload] = useState(false);
    const [message, setMessage] = useState('');
    const [progress, setProgress] = useState(55);

    const initDownloadFile = (url) => {
        axios.get(url, {
            responseType: "blob",
            onDownloadProgress: (progressEvent => {
                let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setProgress(percentCompleted);
            })
        }).then((response) => {
            const data = response.data;
            const url = window.URL.createObjectURL(data);
            const anchor = document.createElement('a');
            anchor.style.display = 'none';
            anchor.href = url;
            const time = new Date();
            anchor.download = 'BioReports'+(time.getTime())+'.zip';
            anchor.click();
            setProgress(0);
            __setDownload(true);
            setMessage('The zip file has been downloaded successfully, check your downloads folder to see the file.');
        }).catch((error) => {
            setProgress(0);
            __setDownload(true);
            setMessage('Error Downloading BioReport Archive. Please contact support@cherish.com.');
        });
    }

    useEffect(() => {
        if (link && openModal) {
            setMessage('Please wait while the report downloads.');
            initDownloadFile(link);
            LocalStorageUtil.removeItem('params');
        }
    },[link])

    const closeModalEmpty = () => {
        AuditTrail.sendLog(PAGES.PROGRAM_PARTICIPANTS, {tag: 'button', event: 'closeModal', action: 'button close modal', program_id: program? program._id : null});
        setMessage('');
        setProgress(0);
        __setDownload(false);
        closeModal();
    }

    return (
        <_Modal
        isOpen={!!openModal}
        style={customStyles}
        contentLabel="Add users to participants"
        label="ProgramDownloadZipDialog"
        event={PAGES.PROGRAM_PARTICIPANTS}
        eventParams={{program_id: program? program._id : null}}>
            <div id="ProgramDownloadZipDialog">
                <div className="__MembersTitle">
                    <h3>Download BioReport(s)</h3>
                </div>
                <div className="__Container">
                    <div className="message center">
                        {
                            message? <span>{message}</span> : ''
                        }
                        <span><b>{progress? progress+'%' : ''}</b></span>
                    </div>
                    <div className="containerButtons">
                        {
                            __download? <>
                                    <button className="primary green" onClick={closeModalEmpty}>
                                        Ok
                                    </button>
                                </> : ''
                        }
                        </div>
                </div>
            </div>
        </_Modal>
    );
}

export default ProgramDownloadZipReportsDialog;
